import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_GRAPH__field_path({ field }: PROPS) {
  /*
   * METHODS
   */

  let [path_item, path_item_in_list] = field.meta.field_path.split_by_first_entry(':');

  let path = path_item_in_list ? path_item_in_list : path_item;

  /*
   * HTML
   */

  return (
    <div className="w-32 min-w-32 max-w-32 flex flex-row items-center flex-shrink-0 text-xs text-gray-400">
      <span className={` truncate ${field.meta.grid2d__is_dimension && 'underline'}`} title={path}>
        {field.meta.grid2d__is_dimension && `• `} {path}
      </span>
    </div>
  );
}
